import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";

function App() {
  return (
    <div className="App font-body" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(10,15,26,0.95)",
            border: "1px solid rgba(0,240,255,0.3)",
            color: "#fff",
            borderRadius: "0",
          },
        }}
      />
    </div>
  );
}

export default App;
